import { axiosInstance, getAuthorizationHeaders } from '@/services/base';

export function setSalary(data) {
    const urlString = `admin/salary/set-salary`;
    return axiosInstance.post(urlString, data, getAuthorizationHeaders());
}

export function showSalaryList({filter = {}, sort = {}, page = 1, limit = 5}) {
    return axiosInstance.get(`admin/salary/list`, {
        params: { filter, sort, page, limit },
        ...getAuthorizationHeaders(),
    });
}

export function showEmployeeSalary(userId) {
    return axiosInstance.get(`admin/salary/show-salary`, {
        params: { userId },
        ...getAuthorizationHeaders(),
    });
}